/* ========================================================================== */
/* File: src/components/layout/Layout.js (Updated)                */
/* ========================================================================== */
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Footer from './Footer';

const Layout = ({ user, activeView, setActiveView, children, onLogout }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleNavClick = (view) => {
        setActiveView(view);
        setIsMobileMenuOpen(false);
    }

    return (
        <div className="app-layout">
            {isMobileMenuOpen && (
                <div 
                    className="mobile-overlay" 
                    onClick={() => setIsMobileMenuOpen(false)}
                ></div>
            )}
            <Sidebar 
                user={user} // Pass user down to sidebar for potential role-based links
                activeView={activeView} 
                setActiveView={handleNavClick}
                isOpen={isMobileMenuOpen}
            />
            <div className="main-container">
                <TopBar user={user} onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} onLogout={onLogout} />
                <main className="page-content">
                    {children}
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default Layout;